<template>
  <Modal :title="isAdd ? '添加供应商' : '编辑供应商'" v-model="value" @on-ok="submit" ok-text="保存" @on-cancel="close" :mask-closable="false" width="580">
    <Form :model="data" :label-width="100" label-position="right" ref="formValidate" :rules="rules">
      <FormItem label="名称：" prop="name">
        <Input type="text" :readonly="isAddGYS" placeholder="请输入" v-model="data.name"></Input>
      </FormItem>
      <FormItem label="编码：" prop="code">
        <Input type="text" :readonly="isAddGYS" placeholder="请输入" v-model="data.code"></Input>
      </FormItem>
      <FormItem label="账号名" prop="userName">
        <Input v-model="data.userName" :maxlength="32" placeholder="请输入" :minlength="2"></Input>
      </FormItem>
      <FormItem label="供应商类别" prop="supplierType" placeholder="请选择">
        <Select v-model="data.supplierType" clearable multiple>
          <Option v-for="item in supplierTypeList" :value="item.text" :key="item.value">{{ item.text }}</Option>
        </Select>
      </FormItem>
      <FormItem label="是否核心供应商" prop="isCoreSupplier">
        <RadioGroup v-model="data.isCoreSupplier">
          <Radio :label="true">是</Radio>
          <Radio :label="false">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="密码" v-if="isAdd||isAddGYS" prop="password">
        <Input v-model="data.password" type="password" placeholder="请输入" :maxlength="32"></Input>
      </FormItem>
      <FormItem label="确认密码" v-if="isAdd||isAddGYS" prop="confirmPassword">
        <Input v-model="data.confirmPassword" type="password" placeholder="请输入" :maxlength="32"></Input>
      </FormItem>
      <!-- <FormItem label="微信OpenId：" prop="wxOpenId">
                <Input type="text" placeholder="请输入" v-model="data.wxOpenId"></Input>
            </FormItem> -->
    </Form>
    <div slot="footer">
      <Button @click="close">取消</Button>
      <Button @click="submit" type="primary">确认</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value !== this.data.password) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!/^(?=.*[0-9].*)(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[#?!@$%^*-].*).{8,20}$/.test(value)) {
        callback(new Error('密码长度8-20位且必须包含大小写字母，数字和以下特殊字符#?!@$%^*-'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      data: { code: '', name: '', password: '', confirmPassword: '', supplierType: null, isCoreSupplier: false },
      supplierTypeList: [],
      rules: {
        name: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change',
            type: 'string',
          },
        ],
        supplierType: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change',
            type: 'array',
          },
        ],
        code: [{ required: true, message: '不能为空', trigger: 'change' }],
        password: [
          {
            required: true,
            message: '不能为空',
            trigger: 'change',
            type: 'string',
          },
          { validator: validatePassword, trigger: 'blur' },
        ],
        confirmPassword: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
            type: 'string',
          },
          { validator: validatePassCheck, trigger: 'blur' },
        ],
        userName: [
          { required: true, message: '不能为空', trigger: 'change', type: 'string' },
          {
            validator: (rule, value, callback) => {
              let reg = /^[0-9a-zA-Z]+$/
              let flog = reg.test(value)
              if (!flog) {
                return callback(new Error('账号名只能由英文字符和数字组成'))
              } else {
                callback()
              }
            },
          },
        ],
        wxOpenId: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    id: {
      type: [String, Number],
    },
    isAdd: {
      type: Boolean,
      default: true,
    },
    isAddGYS: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      let { data } = await this.$Ajax.get('/api/services/app/Supplier/GetSupplierBasicsData')
      console.log('🚀 ~ file: newSupper.vue:125 ~ init ~ data:', data)
      this.supplierTypeList = data.result.supplierTypeList
    },
    close() {
      console.log('🚀 ~ file: newSupper.vue ~ line 43 ~ close ~ close')
      this.$emit('close')
      this.clearData()
    },
    async submit() {
      this.$refs['formValidate'].validate(async (valid) => {
        if (valid) {
          if (this.isAdd || this.isAddGYS) {
            //添加
            // delete this.data.id
            const data = await this.$Ajax.post(
              '/api/services/app/Supplier/CreateSupplierUserAndSupplier',
              this.data
            )
            if (data.data.success) {
              if (data.data.success) {
                this.$Message.success('添加成功')
              } else {
                this.$Message.error('添加失败')
              }
            }
          } else {
            //修改
            this.data.id = this.id
            const data = await this.$Ajax.put(
              '/api/services/app/Supplier/UpdateSupplierUserAndSupplier',
              this.data
            )
            if (data.data.success) {
              this.$Message.success('修改成功')
            } else {
              this.$Message.error('修改失败')
            }
          }
          this.$emit('getTab')
          this.$emit('close')
          this.clearData()
        }
      })
    },
    clearData() {
      this.data = { code: '', name: '', password: '', confirmPassword: '', supplierType: null, isCoreSupplier: false }
      this.$refs['formValidate'].resetFields()
    },
    async getById() {
      const data = await this.$Ajax.get('/api/services/app/Supplier/GetSupplierInfoById', {
        params: { supplierId: this.id },
      })
      console.log(data)
      if (data.data.result.supplierType!=null) {
      if (data.data.result.supplierType.indexOf(',') > -1) {
        data.data.result.supplierType = data.data.result.supplierType.split(',')
      } else {
        data.data.result.supplierType = [data.data.result.supplierType]
      }
      } else {
        data.data.result.supplierType = []
      }
      this.data = { ...data.data.result, isCoreSupplier: !!data.data.result.isCoreSupplier }
    },
  },
  // watch只会监视isAdd  改变了isAdd的值才执行
  watch: {
    // isAdd: {
    //     handler(newV, oldV) {
    //         if (!newV) {
    //             console.log(newV)
    //             console.log('🚀 ~ file: newSupper.vue ~ line 84 ~ handler ~isAdd');
    //             if (this.id) {
    //                 this.getById();
    //             }
    //         } else {
    //             console.log(1);
    //         }
    //     },
    // },
    value: {
      handler(newV, oldV) {
        if (this.isAdd) {
          //新增
          console.log('🚀 ~ file: newSupper.vue ~ line 84 ~ handler ~isAdd')
          this.clearData()
        } else {
          if (this.id) {
            this.getById()
          }
          console.log(1)
        }
      },
    },
  },
}
</script>

<style lang="less" scoped>
// /deep/.ivu-modal-header-inner {
//     font-size: 20px;
//     text-align: center;
// }
// /deep/.ivu-form-item-label {
//     font-size: 16px;
// }
// .title {
//     font-size: 16px;
// }

// .cont {
//     min-height: 400px;
//     max-height: 600px;
//     overflow-y: auto;
//     overflow-x: hidden;
// }
// .department {
//     display: flex;
// }
// .time {
//     margin-left: 50px;
// }
// /deep/.ivu-modal-footer {
//     text-align: center;
// }
// // /deep/.ivu-divider-inner-text{
// //     font-size: 16px;
// // }
// .ivu-row {
//     font-size: 15px;
//     min-height: 20px;
//     margin-top: 5px;
//     // border-bottom: 1px solid #ccc;
// }

// .img-box {
//     width: 100%;
//     display: flex;
//     flex-wrap: wrap;
// }
// .img-box img,
// .img-box video {
//     width: 80px;
//     height: 80px;
//     margin: 0 10px 0 0;
// }

// .video-box .icon {
//     width: 80px;
//     height: 80px;
//     text-align: center;
//     line-height: 80px;
//     margin: 0 10px 0 0;
//     // border: 1px solid red;
// }

// .modal-cont /deep/ .ivu-modal-body {
//     font-size: 20px;
//     text-align: center;
// }
// .modal-cont /deep/ .ivu-modal {
//     top: 300px;
// }

// // 文件上传
// .cont-img {
//     width: 100%;
//     display: flex;
// }
// .demo-upload-list {
//     display: inline-block;
//     width: 80px;
//     height: 80px;
//     text-align: center;
//     line-height: 80px;
//     position: relative;
//     margin-right: 4px;
// }
// .demo-upload-list img {
//     width: 100%;
//     height: 100%;
// }

// .demo-upload-list-cover i {
//     position: absolute;
//     top: 0;
//     right: 0;
//     color: #999;
//     font-size: 20px;
//     cursor: pointer;
//     margin: 0 2px;
// }
</style>
